import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays, Clock } from "lucide-react";
import { api } from "../api";

function renderContent(text) {
  return text.split("\n\n").map((block, i) => {
    const b = block.trim();
    if (!b) return null;
    if (b.startsWith("### ")) return <h3 key={i} className="mt-8 font-display text-lg font-bold text-slate-100">{b.slice(4)}</h3>;
    if (b.startsWith("## ")) return <h2 key={i} className="mt-10 font-display text-xl font-bold text-slate-100">{b.slice(3)}</h2>;
    if (b.startsWith("- ")) {
      return (
        <ul key={i} className="mt-4 space-y-2">
          {b.split("\n").map((li, j) => (
            <li key={j} className="flex gap-2.5 text-sm leading-relaxed text-slate-300">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-400" />
              <span dangerouslySetInnerHTML={{ __html: li.slice(2).replace(/\*\*(.+?)\*\*/g, '<strong class="text-slate-100">$1</strong>') }} />
            </li>
          ))}
        </ul>
      );
    }
    return <p key={i} className="mt-5 text-sm leading-relaxed text-slate-300 sm:text-base" dangerouslySetInnerHTML={{ __html: b.replace(/\*\*(.+?)\*\*/g, '<strong class="text-cyan-300">$1</strong>') }} />;
  });
}

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <main className="mx-auto max-w-3xl px-4 py-40 text-center text-slate-400">Nie znaleziono wpisu.</main>;
  if (!post) return <main className="mx-auto max-w-3xl px-4 py-40 text-center text-slate-500">Ładowanie...</main>;

  return (
    <main className="mx-auto max-w-3xl px-4 pb-24 pt-32 sm:px-6" data-testid="blog-post-page">
      <Link to="/blog" className="flex w-fit items-center gap-2 text-sm text-slate-400 transition-colors hover:text-cyan-300">
        <ArrowLeft className="h-4 w-4" /> Wróć do bloga
      </Link>
      <div className={`mt-8 h-52 rounded-3xl bg-gradient-to-br ${post.gradient} relative overflow-hidden`}>
        <div className="absolute inset-0 opacity-25" style={{ background: "radial-gradient(circle at 70% 20%, rgba(255,255,255,0.5), transparent 55%)" }} />
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-4 text-xs text-slate-500">
        <span className="rounded-full bg-cyan-500/10 border border-cyan-500/30 px-3 py-1 font-bold uppercase tracking-wider text-cyan-300">{post.category}</span>
        <span className="flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" />{post.date}</span>
        <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" />{post.read_time} czytania</span>
      </div>
      <h1 className="mt-5 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl">{post.title}</h1>
      <article className="mt-6">{renderContent(post.content)}</article>
    </main>
  );
}
